<template>
  <nav
    class="hidden lg:flex items-stretch bg-brand-primary-600"
    ref="hubLinks"
  >
    <div class="navbar-start">
      <a
        class="align-items-center has-background-transparent has-colour-white smallcaps flex shrink-0 grow-0 px-3 py-1 text-base leading-4 lowercase"
        href="https://copytechgroup.co.uk/"
        title="Printers and printer servicing for businesses"
      >
        Copytech Group
      </a>
    </div>
    <div class="navbar-end">
      <a
        class="align-items-center has-background-transparent has-colour-white smallcaps flex shrink-0 grow-0 px-3 py-1 text-base leading-4 lowercase"
        :href="'tel:' + cleanTel(phoneDefault)"
      >
        <span class="icon h-4"> <Icon :icon="faPhone" /></span>
        <span>{{ phoneDefault }}</span>
      </a>
    </div>
  </nav>
</template>
<script setup>
import { ref, onMounted, useTemplateRef } from 'vue'
import { Icon } from '@repo/ui'
import { faPhone } from '@repo/icons/light/faPhone'

const hubLinks = useTemplateRef('hubLinks')

const phoneDefault = ref('0207 237 4545')

function cleanTel(val) {
  const re = /\s/gi
  return val.replace(re, '')
}

onMounted(() => {
  const href = window.location.href
  const el = hubLinks.value.querySelector(`a[href^="${href}"]`)
  if (el) {
    el.style.backgroundColor = 'rgba(0, 0, 0, .3)'
  }
})
</script>
